import { render, staticRenderFns } from "./lookOne.vue?vue&type=template&id=391f8188&scoped=true&"
import script from "./lookOne.vue?vue&type=script&lang=js&"
export * from "./lookOne.vue?vue&type=script&lang=js&"
import style0 from "./lookOne.vue?vue&type=style&index=0&id=391f8188&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391f8188",
  null
  
)

export default component.exports